// src/config/plotConfigs/terminationMetageneConfig.js

export const terminationMetageneConfig = {
  sections: [
    {
      fields: [
        {
          id: "minread",
          label: "Min Read Length",
          type: "number",
          placeholder: "20",
          min: 1,
          max: 1000,
          tooltip: "The shortest read length included in the analysis.",
          width: 3,
          triggersSmartAdjustment: true,
        },
        {
          id: "maxread",
          label: "Max Read Length",
          type: "number",
          placeholder: "150",
          min: 1,
          max: 1000,
          tooltip: "The longest read length included in the analysis.",
          width: 3,
          triggersSmartAdjustment: true,
        },
        {
          id: "minUtr",
          label: "Min UTR Length",
          type: "text",
          placeholder: "50",
          tooltip:
            "The minimum length of the 3'UTR in nucleotides. Transcripts with a shorter 3'UTR length than this value will be excluded from the plot.s",
          width: 3,
        },
        {
          id: "minCount",
          label: "Min Read Count",
          type: "text",
          placeholder: "10",
          tooltip:
            "The minimum number of reads required to be mapped to an entire transcript. Transcripts with a total read count less than this value will be excluded from the plot.",
          width: 3,
        },
        {
          id: "downstreamSelection",
          label: "Downstream Region",
          type: "radio",
          options: [
            { value: "downstream_3utr", label: "3'UTR" },
            { value: "downstream_minusframe", label: "First stop -1 frame" },
            { value: "downstream_inframe", label: "First stop in-frame" },
            { value: "downstream_plusframe", label: "First stop +1 frame" },
          ],
          tooltip:
            "Select how far downstream of the annotated CDS stop reads will be taken from. 3'UTR will take into account all reads downstream of the annotated CDS. First stop -1 frame will only consider reads between the annotated CDS stop and first stop after the CDS stop in the -1 frame.First stop in-frame will only consider reads between the annotated CDS stop and first in-frame stop. First stop +1 frame will only consider reads between the annotated CDS stop and first stop after the CDS stop in the +1 frame.",
          width: 6,
        },
        {
          id: "normaliseMethod",
          label: "Normalize Method",
          type: "radio",
          options: [
            { value: "ard", label: "Average Read Density" },
            { value: "read_depth", label: "Normalize by Read Depth" },
            { value: "none", label: "None" },
          ],
          tooltip:
            "If set to 'Average read density' counts at each position in a transcript are normalised by the total read count for that transcript. Counts are then also normalised by the total number of transcripts that contribute to the plot. If set to 'Normalise by read depth' the number of unambiguously mapped reads (coding and noncoding) in each group will be calculated for each group. The reads in each group will then be reduced by a factor difference relative to the group with the lowest number of mapped reads. For example, if you have samples in both the Group 1 and Group 2 boxes below and the mapped reads from all samples in Group 1 add up to 2,000,000 and the mapped reads in all the samples from Group 2 add up to 1,000,000, then the count at each position and each frame in Group 1 will be reduced by half. The counts for Group 2 would remain unchanged (i.e raw counts).If only one group is being used this option will have no effect..If this option is set to 'None' only raw counts will be displayed for all groups.",
          width: 6,
        },
        {
          id: "tranSelection",
          label: "Transcripts",
          type: "radio",
          options: [
            { value: "prin_trans", label: "Principal" },
            { value: "all_trans", label: "All" },
            { value: "custom_trans", label: "Custom" },
          ],
          tooltip:
            "Use only principal transcripts, all transcripts or a custom list (enter a comma or space seperated list of transcript ID's in the input box).",
          width: 4,
        },
        {
          id: "email",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 4,
        },
        {
          id: "customTranList",
          label: "Custom Transcript List",
          type: "textarea",
          placeholder: "Enter transcript IDs...",
          tooltip: "Enter custom transcript list when 'Custom' is selected",
          width: 12,
          rows: 3,
          showIf: (settings) => settings.tranSelection === "custom_trans",
        },
      ],
    },
  ],
};

// src/config/plotConfigs/terminationMetageneConfig.js
export const terminationMetageneDefaults = {
  minread: 20,
  maxread: 35, // maps to maxread
  minUtr: 45, // maps to min_utr
  minCount: 100, // maps to min_count
  tranSelection: "prin_trans", // maps to tran_selection
  customTranList: "", // maps to custom_tran_list
  downstreamSelection: "downstream_3utr", // maps to downstream_selection
  normaliseMethod: "ard", // maps to normalise_method
  email: false,
};

export const terminationMetageneValidation = {
  minread: { required: true, min: 1, max: 1000, label: "Min read length" },
  maxread: { required: true, min: 1, max: 1000, label: "Max read length" },
  minUtr: { required: true, min: 0, label: "Min UTR length" },
  minCount: { required: true, min: 0, label: "Min read count" },
  custom: (value, allSettings) => {
    if (allSettings.minread >= allSettings.maxread) {
      return "Min read length must be less than max read length";
    }
    if (
      allSettings.tranSelection === "custom" &&
      !allSettings.customTranList.trim()
    ) {
      return "Please provide custom transcript list";
    }
    return null;
  },
};
